import { optionSchema } from "@/common/schemas/option.schema"
import { z } from "zod"

export const createSchema = z.object({
  display_name: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(64, { message: 'Tamanho máximo: 64 caracteres' }),
  sku: z.string().optional(),
  description: z.string().min(3, { message: 'Tamanho minimo: 3 caracteres' }).max(512, { message: 'Tamanho máximo: 512 caracteres' }),
  available_from: z.string({ message: 'Campo obrigatório' }),
  available_until: z.string().optional(),
  reference_price: z.string({message: 'Campo obrigatório'}),
  points_to_redeem: z.string().min(1, { message: 'Campo obrigatório' }),
  establishment_company_branch_id: optionSchema,
  product_badges_attributes: z.array(optionSchema).optional(),
  pictures_attachments_attributes: z
    .array(
      z.object({
        id: z.string(),
        file: z.custom<string | File>(),
      }),
    )
    .optional(),
})

export type RewardItemValidationSchema = z.infer<typeof createSchema>
